import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    viewSettings: translate({
      id: 'orders.smsNotifications.notification.cta',
    }),

    sms: translate({
      id: 'orders.smsNotifications.notification.kind.sms',
    }),

    email: translate({
      id: 'orders.smsNotifications.notification.kind.email',
    }),

    senderText: translate({
      id: 'orders.smsNotifications.notification.sentBy.sender',
    }),

    label: (status: uui.domain.client.rm.OrderStepEmailOrSMSNotification['status']) =>
      translate({
        id: `orders.smsNotifications.notification.status.${status.toLowerCase()}` as uui.domain.intl.LocalizationIdentifier,
      }),

    errorCodeLabel: (errorCode: uui.domain.client.rm.SmsErrorCode) =>
      translate({
        id: `orders.smsNotifications.notification.errorCode.${errorCode}` as const,
      }),

    completedStatus: translate({
      id: 'orders.smsNotifications.notification.status.completed',
    }),

    pendingStatus: translate({
      id: 'orders.smsNotifications.notification.status.pending',
    }),

    failedStatus: translate({
      id: 'orders.smsNotifications.notification.status.failed',
    }),
    sentStatus: translate({
      id: 'orders.smsNotifications.notification.status.sent',
    }),

    duration: translate({ id: 'orders.smsNotifications.voiceCall.duration' }),

    voiceCall: translate({ id: 'orders.smsNotifications.voiceCall.title' }),

    byDriver: (driverName: string, phoneNumber: string) =>
      translate({
        id: 'orders.smsNotifications.voiceCall.byDriver',
        values: { driverName, phoneNumber },
      }),

    show: translate({ id: 'orders.smsNotifications.voiceCall.show' }),
    hide: translate({ id: 'orders.smsNotifications.voiceCall.hide' }),

    noGpsDataAvailable: translate({ id: 'orders.smsNotifications.voiceCall.noGps' }),
  }))

  return api
}
